// docs: https://github.com/altostra/type-validations#readme
import { objectOf, recordOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementRecommendationsMetadataResult = objectOf({
  is_paid: boolean,
  train_type_to_allowed_new_models: recordOf({
    key: string,
    value: number,
  }),
});
